import React from 'react'

export default function IconChevronsUp({ color = '', style = {} }) {
    let fillColor = '#7246B1'
    if (color) fillColor = color
    let className = 'icons-icon'

    return (
        <svg
            className={className}
            style={style}
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.293 15.707C4.10553 15.5195 4.00021 15.2652 4.00021 15C4.00021 14.7348 4.10553 14.4805 4.293 14.293L9.293 9.293C9.48053 9.10553 9.73484 9.00021 10 9.00021C10.2652 9.00021 10.5195 9.10553 10.707 9.293L15.707 14.293C15.8892 14.4816 15.99 14.7342 15.9877 14.9964C15.9854 15.2586 15.8802 15.5094 15.6948 15.6948C15.5094 15.8802 15.2586 15.9854 14.9964 15.9877C14.7342 15.99 14.4816 15.8892 14.293 15.707L10 11.414L5.707 15.707C5.51947 15.8945 5.26516 15.9998 5 15.9998C4.73484 15.9998 4.48053 15.8945 4.293 15.707ZM4.293 9.707C4.10553 9.51947 4.00021 9.26516 4.00021 9C4.00021 8.73484 4.10553 8.48053 4.293 8.293L9.293 3.293C9.48053 3.10553 9.73484 3.00021 10 3.00021C10.2652 3.00021 10.5195 3.10553 10.707 3.293L15.707 8.293C15.8892 8.4816 15.99 8.7342 15.9877 8.9964C15.9854 9.2586 15.8802 9.50941 15.6948 9.69482C15.5094 9.88023 15.2586 9.9854 14.9964 9.98767C14.7342 9.98995 14.4816 9.88916 14.293 9.707L10 5.414L5.707 9.707C5.51947 9.89447 5.26516 9.99979 5 9.99979C4.73484 9.99979 4.48053 9.89447 4.293 9.707Z"
                fill={fillColor} />
        </svg>
    )
}